var React   = require('react');
var App = React.createClass({displayName: "App",

displayNone: function(e){
    document.getElementById('PopUp').style.display = "none";
    this.props.afterTimeOut();
  },

  getInitialState: function(){
    return {time: new Date(this.props.givenDate)/1000}
  },

  update: function(){
    var newTime = this.state.time - 1; // minus one sec from initial time
    this.setState({time:newTime});
    if(this.state.time ===0){
      clearInterval(this.decr);
      this.props.afterUnmount
    }
  },

  render: function(){

  var formattedGivenDate = new Date(this.props.givenDate);
  var today = new Date();
  var msDiff =formattedGivenDate - today;
  var days = parseInt(msDiff/(24*3600*1000));
  var hours =parseInt(msDiff/(3600*1000)-(days*24));
  var mins = parseInt(msDiff/(60*1000)-(days*24*60)-(hours*60));
  var secs = parseInt(msDiff/(1000)-(mins*60)-(days*24*60*60)-(hours*60*60));

    return(
      React.createElement("div", {className: "react-countdown-container"}, 
        React.createElement("h1", null, days, " days ", hours," hours ", mins," mins ",  secs, " secs ")
      )
    )
  },
  componentDidMount: function(){
    this.decr = setInterval(this.update,1000)
  }
})
module.exports = App;



//////////////////
// WEBPACK FOOTER
// ./~/react-countdown-to-future-date/react-countdown-to-future-date.js
// module id = 453
// module chunks = 35783957827783